import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const FORM_URL = "https://forms.gle/WPZkSRm4eEePSotY7";

const getFormPopupKey = (username) => `formPopupDismissed_${username}`;

const FormPopup = ({ open, onClose, storageKey }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = (forceDismiss = false) => {
    if (forceDismiss === true || dontShowAgain) {
      localStorage.setItem(storageKey, "true");
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={() => handleClose()} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
        <MDTypography variant="h5" fontWeight="bold">
          Hey Delta Online students!
        </MDTypography>
        <IconButton
          onClick={() => handleClose()}
          sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <MDTypography variant="body2" mb={2}>
          Please take a moment to fill out this short survery.
        </MDTypography>
        <MDBox mt={2} mb={1}>
          <MDButton
            component="a"
            href={FORM_URL}
            target="_blank"
            rel="noopener"
            variant="gradient"
            color="info"
            fullWidth
            onClick={() => handleClose(true)}
          >
            Open Form
          </MDButton>
        </MDBox>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 2, py: 1.5 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
          }
          label={<MDTypography variant="caption">Don&apos;t show this again</MDTypography>}
        />
        <MDButton variant="gradient" color="info" onClick={() => handleClose()}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export { getFormPopupKey };
export default FormPopup;
